/* eslint-disable camelcase */
import React from 'react'
import dayjs from 'dayjs'

import { CbSubscription } from '@lmc/common/types'
import Badge from '../../../../../atoms/Badge'
import colors from '@lmc/common/constants'
import Popover from '../../../../../atoms/Popover'
import Text from '../../../../../atoms/Text'

type StatusProps = {
  sub: CbSubscription
}

export const Status = ({ sub }: StatusProps) => {
  const colorLookup = {
    active: colors.green,
    in_trial: colors.informationblue,
    cancelled: colors.red,
    non_renewing: colors.orange,
    overdue: colors.red,
    future: colors.informationblue,
  }
  const statusLookup = {
    in_trial: 'IN TRIAL',
    active: 'ACTIVE',
    cancelled: 'CANCELLED',
    non_renewing: 'NON RENEWING',
    overdue: 'OVERDUE',
    future: 'FUTURE',
  }

  const hasSubContent = ['in_trial', 'cancelled'].includes(sub.status)

  return (
    <Popover
      content={
        <div
          style={
            hasSubContent
              ? {
                  backgroundColor: colors.white,
                  padding: 5,
                  borderRadius: 5,
                }
              : {}
          }
        >
          {sub.status === 'in_trial' && !sub.cancelled_at && (
            <Text as="p2" color="black">
              {/* @ts-ignore */}
              Ends {dayjs.unix(sub.trial_end).format('DD-MM-YY')}
            </Text>
          )}
          {sub.status === 'in_trial' && sub.cancelled_at && (
            <Text as="p2" color="black">
              Scheduled for cancellation
            </Text>
          )}
          {sub.status === 'cancelled' && (
            <Text as="p2" color="black">
              Contact support to re-activate
            </Text>
          )}
        </div>
      }
    >
      <div>
        <Badge
          style={{
            width: 'max-content',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
          // @ts-ignore
          text={statusLookup[sub.status] || sub.status}
          // @ts-ignore
          color={colorLookup[sub.status] || 'successgreen'}
          textColor="white"
        />
      </div>
    </Popover>
  )
}

export default Status
